module.exports = __webpack_public_path__ + "sc.svg?7b4b06e6611268c6ebf0994eeeabf2a0";